module.exports = __webpack_public_path__ + "img/16.284da53d.jpg";